/**
 * Billing Settings Component
 *
 * Displays billing history and payment information.
 */

import BillingHistory from '@components/subscription/BillingHistory';

export function BillingSettings() {
  return (
    <div className="space-y-6">
      <div className="bg-white shadow rounded-lg">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Billing History</h3>
          <p className="mt-1 text-sm text-gray-500">
            View your payment history and download invoices
          </p>
        </div>
        <div className="p-6">
          <BillingHistory />
        </div>
      </div>

      {/* Future: Payment Methods Section */}
      <div className="bg-white shadow rounded-lg">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Payment Methods</h3>
          <p className="mt-1 text-sm text-gray-500">
            Manage your payment methods
          </p>
        </div>
        <div className="px-6 py-8 text-center">
          <div className="text-gray-400 mb-2">
            <svg
              className="mx-auto h-12 w-12"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
              />
            </svg>
          </div>
          <p className="text-sm text-gray-500">
            Payment method management coming soon
          </p>
        </div>
      </div>
    </div>
  );
}

export default BillingSettings;
